<template>
  <v-container>
    <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
      <v-card-text class="secondary-font pa-3">
        <v-form ref="enrollmentForm">
          <v-container class="mt-3">
            <v-row>
              <v-col cols="12" class="my-0 py-0">
                <span class="mb-0 mr-1 primary--text font-weight-medium">
                  Program:
                </span>
                <span class="mb-0 black--text">
                  {{
                    enrollmentYear &&
                    enrollmentYear.program_detail &&
                    enrollmentYear.program_detail.program.program_desc
                  }}
                </span>
              </v-col>
              <v-col cols="12" class="mt-0 mb-5 py-0">
                <span class="mb-0 mr-1 primary--text font-weight-medium">
                  Academic Year:
                </span>
                <span class="mb-0 black--text">
                  {{
                    enrollmentYear &&
                    enrollmentYear.academic_year &&
                    enrollmentYear.academic_year.academic_year
                  }}
                </span>
              </v-col>
            </v-row>
            <template v-for="enrollmentTerm in sortedEnrollmentTerms">
              <v-row
                class="grey lighten-3 py-2"
                :key="enrollmentTerm.uuid + '1'"
              >
                <v-col cols="12" class="my-0 py-0">
                  <span class="mb-0 mr-1 ml-4 primary--text font-weight-medium">
                    Term:
                  </span>
                  <span class="mb-0 black--text">
                    {{ enrollmentTerm.academic_term.academic_term }}
                  </span>
                </v-col>
              </v-row>
              <v-simple-table
                dense
                class="mt-5 mb-10 simple-table"
                :key="enrollmentTerm.uuid + '2'"
              >
                <thead>
                  <tr>
                    <th class="primary--text">
                      <span class="primary--text">Subject</span>
                    </th>
                    <th class="primary--text">
                      <span class="primary--text">ECTS</span>
                    </th>
                    <th class="primary--text">
                      <span class="primary--text">Is Elective</span>
                    </th>
                    <th class="primary--text">
                      <span class="primary--text">Out Of Program</span>
                    </th>
                    <th class="primary--text">
                      <span class="primary--text">Campus</span>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(enrollmentDetail, index) in formData[
                      enrollmentTerm.uuid
                    ]"
                    :key="enrollmentDetail.uuid + index"
                  >
                    <td>
                      <v-select
                        :items="
                          getSubjects(
                            enrollmentTerm,
                            enrollmentDetail.is_elective,
                            formData[enrollmentTerm.uuid][index]
                              .uuid_program_term_detail
                          )
                        "
                        v-model="
                          formData[enrollmentTerm.uuid][index]
                            .uuid_program_term_detail
                        "
                        outlined
                        dense
                        hide-details="auto"
                        @change="handleFormDataChange"
                        :rules="[validations.required]"
                        :readonly="
                          !isEditableEnrollmentDetail(
                            enrollmentDetail,
                            enrollmentTerm
                          )
                        "
                      ></v-select>
                    </td>
                    <td>
                      {{
                        getSubjectEcts(
                          enrollmentTerm.academic_term.uuid,
                          formData[enrollmentTerm.uuid][index]
                            .uuid_program_term_detail
                        )
                      }}
                    </td>
                    <td>{{ getIsElectiveText(enrollmentDetail) }}</td>
                    <td>{{ getOutOfProgramText(enrollmentDetail) }}</td>
                    <td>
                      {{
                        getCampus(
                          enrollmentTerm.academic_term.uuid,
                          formData[enrollmentTerm.uuid][index]
                            .uuid_program_term_detail
                        )
                      }}
                    </td>
                    <td>
                      <v-btn
                        color="secondary"
                        class="text-none ml-3"
                        x-small
                        @click="
                          removeEnrollmentDetail(
                            enrollmentTerm.uuid,
                            formData[enrollmentTerm.uuid][index].uuid
                          )
                        "
                        v-if="
                          isEditableEnrollmentDetail(
                            enrollmentDetail,
                            enrollmentTerm
                          )
                        "
                        ><v-icon x-small>mdi-trash-can</v-icon>Remove</v-btn
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <v-btn
                        color="secondary"
                        class="text-none ml-3"
                        x-small
                        @click="addEnrollmentDetail(enrollmentTerm.uuid)"
                        v-if="isEditableEnrollmentDetail(null, enrollmentTerm)"
                        ><v-icon x-small>mdi-plus</v-icon>Add New</v-btn
                      >
                    </td>
                    <td class="font-weight-bold">
                      {{
                        getTermEcts(
                          enrollmentTerm.academic_term.uuid,
                          enrollmentTerm.uuid
                        )
                      }}
                    </td>
                    <td colspan="3"></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </template>
            <v-simple-table
              dense
              class="mt-5 mb-10 py-1 simple-table grey lighten-3"
            >
              <thead>
                <th>
                  <span class="mb-0 mr-1 ml-4 primary--text">
                    Required ECTS :
                  </span>
                  <span class="mb-0 black--text">
                    {{ requiredEct }}
                  </span>
                </th>
                <th>
                  <span class="mb-0 mr-1 ml-4 primary--text">
                    Total ECTS :
                  </span>
                  <span class="mb-0 black--text">
                    {{ getTotalEcts() }}
                  </span>
                </th>
                <th>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                      class="text-capitalize mr-3"
                      color="secondary"
                      outlined
                      :to="{ name: 'enrollments' }"
                      exact
                      v-if="isEditableEnrollmentDetail(null, null)"
                    >
                      cancel
                    </v-btn>
                    <v-btn
                      class="text-capitalize"
                      color="secondary"
                      @click="handleSave"
                      v-if="isEditableEnrollmentDetail(null, null)"
                      >Save</v-btn
                    >
                  </v-col>
                </th>
              </thead>
            </v-simple-table>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import enrollmentService from "@/services/enrollment-service";
import {
  enrollmentDetailIsElectiveOptions,
  outOfProgramOptions,
} from "@/utilities/constants-utility";
import validations from "@/utilities/validations-utility";
import { v4 as uuid } from "uuid";
import { enrollmentDetailModel } from "@/utilities/models-utility";
import notificationsUtility from "@/utilities/notifications-utility";
export default {
  data() {
    return {
      sortedEnrollmentTerms: [],
      formData: {},
      subjects: {},
      enrollmentYear: {},
      validations,
    };
  },
  mounted() {
    this.getEnrollmentDetails();
  },
  computed: {
    requiredEct() {
      return (
        this.enrollmentYear &&
        this.enrollmentYear.program_detail &&
        this.enrollmentYear.program_detail.program.ects_required
      );
    },
  },
  methods: {
    handleFormDataChange() {
      this.formData = { ...this.formData };
    },
    getSubjects(term, isElective, current) {
      const termSelectedSubjects = JSON.parse(
        JSON.stringify(this.formData[term.uuid])
      ).map((subject) => subject.uuid_program_term_detail);
      const subjects = JSON.parse(JSON.stringify(this.subjects));
      return subjects[term.academic_term.uuid]
        .filter((subject) => {
          let eligible = true;
          eligible =
            subject.is_elective == isElective &&
            subject.appear_in_campus_enrollment == 1 &&
            (!termSelectedSubjects.includes(subject.value) ||
              subject.value == current);
          return eligible;
        })
        .sort((a, b) => (a.text > b.text ? 1 : -1));
    },
    getEnrollmentDetails() {
      enrollmentService
        .getEnrollmentYear(this.$route.params.enrollmentYear)
        .then((response) => {
          this.sortedEnrollmentTerms = response.data.enrollment_terms.sort(
            (a, b) =>
              a.academic_term.academic_term > b.academic_term.academic_term
                ? 1
                : -1
          );
          this.sortedEnrollmentTerms.forEach((enrollmentTerm) => {
            this.formData[enrollmentTerm.uuid] =
              enrollmentTerm.enrollment_details.map((enrollmentDetail) => ({
                uuid: enrollmentDetail.uuid,
                uuid_program_term_detail:
                  enrollmentDetail.program_term_detail.uuid,
                is_elective: enrollmentDetail.is_elective,
                out_of_program: enrollmentDetail.out_of_program,
              }));
          });
          response.data.program_detail.program_terms.forEach((programTerm) => {
            this.subjects[programTerm.academic_term.uuid] =
              programTerm.program_term_details
                .sort((a, b) =>
                  a.subject.subject_code > b.subject.subject_code ? 1 : -1
                )
                .map((programTermDetail) => ({
                  text: `${programTermDetail.subject.subject_code} - ${programTermDetail.subject.subject_desc}`,
                  value: programTermDetail.uuid,
                  ects: programTermDetail.subject.ects,
                  campus: programTermDetail.campus.campus_desc,
                  is_elective: programTermDetail.is_elective,
                  appear_in_campus_enrollment:
                    programTermDetail.appear_in_campus_enrollment,
                  is_foreign: false,
                }));
          });
          response.data.enrollment_terms.forEach((enrollmentTerm) => {
            enrollmentTerm.enrollment_details.forEach((enrollmentDetail) => {
              const subjects = JSON.parse(
                JSON.stringify(this.subjects[enrollmentTerm.academic_term.uuid])
              );
              const subject = subjects.find(
                (programTermDetail) =>
                  programTermDetail.value ==
                  enrollmentDetail.program_term_detail.uuid
              );
              if (!subject) {
                this.subjects = {
                  ...JSON.parse(JSON.stringify(this.subjects)),
                  [enrollmentTerm.academic_term.uuid]: [
                    ...JSON.parse(
                      JSON.stringify(
                        this.subjects[enrollmentTerm.academic_term.uuid]
                      )
                    ),
                    {
                      text: `${enrollmentDetail.program_term_detail.subject.subject_code} - ${enrollmentDetail.program_term_detail.subject.subject_desc}`,
                      value: enrollmentDetail.program_term_detail.uuid,
                      ects: enrollmentDetail.program_term_detail.subject.ects,
                      campus:
                        enrollmentDetail.program_term_detail.campus.campus_desc,
                      is_elective: enrollmentDetail.is_elective,
                      appear_in_campus_enrollment:
                        enrollmentDetail.appear_in_campus_enrollment,
                      is_foreign: true,
                    },
                  ],
                };
              }
            });
          });
          this.enrollmentYear = response.data;
        });
    },
    getSubjectText(enrollmentDetail) {
      return enrollmentDetail.program_term_detail &&
        enrollmentDetail.program_term_detail.subject
        ? `${enrollmentDetail.program_term_detail.subject.subject_code} ${enrollmentDetail.program_term_detail.subject.subject_desc}`
        : "";
    },
    getSubjectEcts(academicTermUuid, programTermDetailUuid) {
      const subjects = JSON.parse(
        JSON.stringify(this.subjects[academicTermUuid])
      );
      const subject = subjects.find(
        (programTermDetail) => programTermDetail.value == programTermDetailUuid
      );
      return subject ? subject.ects : 0;
    },
    getCampus(academicTermUuid, programTermDetailUuid) {
      const subjects = JSON.parse(
        JSON.stringify(this.subjects[academicTermUuid])
      );
      const subject = subjects.find(
        (programTermDetail) => programTermDetail.value == programTermDetailUuid
      );
      return subject?.campus || null;
    },
    getIsForeign(academicTermUuid, programTermDetailUuid) {
      const subjects = JSON.parse(
        JSON.stringify(this.subjects[academicTermUuid])
      );
      const subject = subjects.find(
        (programTermDetail) => programTermDetail.value == programTermDetailUuid
      );
      return subject?.is_foreign;
    },
    getTermEcts(academicTermUuid, enrollmentTermUuid) {
      let totalEcts = 0;
      Object.keys(this.formData[enrollmentTermUuid]).forEach((index) => {
        totalEcts += this.getSubjectEcts(
          academicTermUuid,
          this.formData[enrollmentTermUuid][index].uuid_program_term_detail
        );
      });
      return totalEcts;
    },
    getTotalEcts() {
      let totalEcts = 0;
      this.sortedEnrollmentTerms.forEach((term) => {
        totalEcts += this.getTermEcts(term.academic_term.uuid, term.uuid);
      });
      return totalEcts;
    },
    getOutOfProgramText(enrollmentDetail) {
      const isElectiveOption = outOfProgramOptions.find(
        (option) => option.value === enrollmentDetail.out_of_program
      );
      return isElectiveOption ? isElectiveOption["text"] : "";
    },
    getIsElectiveText(enrollmentDetail) {
      const isElectiveOption = enrollmentDetailIsElectiveOptions.find(
        (option) => option.value === enrollmentDetail.is_elective
      );
      return isElectiveOption ? isElectiveOption["text"] : "";
    },
    isEditableEnrollmentDetail(enrollmentDetail, enrollmentTerm) {
      const configurations = this.$store.state.common.configurations;
      let editable =
        configurations &&
        this.$moment(configurations.enrollment_start_date).isBefore(
          this.$moment()
        ) &&
        this.$moment(configurations.enrollment_end_date).isAfter(
          this.$moment()
        ) &&
        configurations.edit_enrollment_student_status.includes(
          this.enrollmentYear?.student_status?.uuid
        );
      if (enrollmentTerm) {
        editable =
          editable &&
          configurations.academic_term &&
          configurations.academic_term.academic_term <=
            enrollmentTerm.academic_term.academic_term;
      }
      if (enrollmentDetail) {
        editable =
          editable &&
          enrollmentDetail.is_elective == 1 &&
          !this.getIsForeign(
            enrollmentTerm.academic_term.uuid,
            enrollmentDetail.uuid_program_term_detail
          );
      }
      return editable;
    },
    handleSave() {
      if (this.$refs.enrollmentForm.validate()) {
        if (this.getTotalEcts() == parseInt(this.requiredEct)) {
          enrollmentService
            .updateEnrollment(this.$route.params.enrollmentYear, this.formData)
            .then(() => {
              this.$router.push({ name: "enrollments" });
            });
        } else {
          notificationsUtility.pushNotification({
            type: "error",
            message: `${this.requiredEct} ETCS Required`,
          });
        }
      }
    },
    removeEnrollmentDetail(enrollmentTermUuid, uuid) {
      this.formData = {
        ...this.formData,
        [enrollmentTermUuid]: [
          ...this.formData[enrollmentTermUuid].filter(
            (item) => item.uuid != uuid
          ),
        ],
      };
    },
    addEnrollmentDetail(enrollmentTermUuid) {
      this.formData = {
        ...this.formData,
        [enrollmentTermUuid]: [
          ...this.formData[enrollmentTermUuid],
          { ...enrollmentDetailModel, uuid: uuid(), is_elective: 1 },
        ],
      };
    },
  },
};
</script>
